var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfetti = function SvgConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 255,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0EE40",
    fillRule: "evenodd",
    d: "m283.281 165.594-3.568 3.682 6.746 9.685 3.652-3.891z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E6FFF",
    fillRule: "evenodd",
    d: "m278.676 241.134-6.873 9.864 5.007 2.117 6.645-9.871z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB7D4D",
    fillRule: "evenodd",
    d: "m243.086 185.716 3.685 4.591 4.88-3.483-2.828-4.996z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CF2074",
    fillRule: "evenodd",
    d: "m71 173.404 6.99 2.659 3.876-13.177-6.686-2.698zM310.195 135.457l2.434 2.364 4.706-4.845-1.863-2.015z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9CF8A",
    fillRule: "evenodd",
    d: "m56.392 48.703-3.798 4.365 11.069 6.264 2.959-6.489z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FADE4D",
    fillRule: "evenodd",
    d: "m280.969 92.95 5.195 8.318 5.011-1.157-4.69-10.283z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E6FFF",
    fillRule: "evenodd",
    d: "m5.494 127.398-3.844 2.669 4.335 9.861 3.956-2.84z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9CF8A",
    fillRule: "evenodd",
    d: "m24.46 239.786 6.506 5.792 6.264-6.282-5.354-6.593z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE68C",
    d: "m120.562 122.305-4.218 1.268-4.218-1.268 1.236 4.329-1.236 4.329 4.218-1.268 4.218 1.268-1.235-4.329zM147.617 0l-4.218 1.268L139.181 0l1.235 4.33-1.235 4.329 4.218-1.268 4.218 1.268-1.235-4.33z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB0B6",
    d: "M239.379 53.933c1.991-.903 3.55-3.15 2.71-5.346-.307-.805-.84-1.335-1.268-1.76l-.136-.137c-.545-.55-.735-1.09-.733-1.257.086-.086.371-.242.562-.346.525-.287 1.179-.644 1.686-1.336.518-.706.734-1.634.594-2.546-.139-.913-.623-1.728-1.326-2.236l-1.935 2.818a.3.3 0 0 1-.051-.048.3.3 0 0 1 .035-.062c-.068.086-.377.255-.582.367-.518.283-1.227.67-1.738 1.412-1.275 1.851-.351 4.191 1.13 5.69l.157.157c.174.173.437.434.479.543 0 .149-.354.667-.942.934zM350.963 145.088c2.187.026 4.55-1.348 4.721-3.693.063-.86-.195-1.565-.402-2.132l-.066-.181c-.26-.73-.203-1.299-.13-1.45.114-.041.437-.062.655-.075.597-.037 1.341-.084 2.094-.495.768-.42 1.357-1.169 1.617-2.054.26-.886.168-1.829-.254-2.588l-2.946 1.733a.2.2 0 0 1-.026-.065.2.2 0 0 1 .057-.042c-.097.049-.449.071-.682.086-.589.036-1.396.087-2.173.542-1.939 1.136-2.095 3.647-1.388 5.632l.075.209c.085.23.212.579.204.695-.063.135-.603.454-1.249.447z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FADE4D",
    d: "M191.358 142.15c2.576 1.14 6.072.711 7.464-1.979.51-.986.563-1.952.605-2.728l.015-.249c.062-.996.418-1.641.581-1.783.156.009.549.149.814.244.726.259 1.63.581 2.731.475 1.122-.107 2.2-.695 2.957-1.612.758-.917 1.127-2.081 1.012-3.193l-4.368.557a.3.3 0 0 1 .002-.09.3.3 0 0 1 .089-.02c-.14.009-.568-.144-.851-.245-.716-.255-1.698-.605-2.849-.46-2.873.362-4.331 3.257-4.501 5.966l-.017.285c-.017.316-.043.793-.112.927-.142.127-.944.232-1.705-.104z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1CBFF",
    d: "M180.422 54.52c-1.855 0-3.359-1.543-3.359-3.448 0-1.904 1.504-3.447 3.359-3.447s3.359 1.544 3.359 3.447c0 1.905-1.504 3.448-3.359 3.448M257.683 123.448l-3.808 1.325-3.223-2.468.052 4.127-3.283 2.383 3.839 1.225 1.194 3.941 2.322-3.37 4.021.053-2.405-3.308zM355.089 208.955l-3.808 1.326-3.223-2.469.052 4.127-3.283 2.383 3.84 1.226 1.193 3.941 2.322-3.37 4.021.053-2.405-3.308zM306.824 10.135l-3.808 1.326-3.223-2.469.051 4.127-3.283 2.383 3.84 1.225 1.194 3.941 2.322-3.37 4.021.053-2.406-3.307z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9238A",
    d: "M314.647 219a140 140 0 0 1 8.915-8.115l-6.52-5.885a148 148 0 0 0-9.48 8.629z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB0B6",
    d: "M181.754 104.404a54 54 0 0 1 3.184-3.427l-2.329-2.485a58 58 0 0 0-3.384 3.644z"
  })));
};
export default SvgConfetti;